<template>
  <div class="footer">
    <b-container>
      <b-row>
        <b-col sm="12" md="2" offset-md="3">
          <div class="category">
            <router-link to="/Services">{{services}}</router-link>
          </div>
          <ul class="list">
            <li><router-link to="/Services/Consulting">Professional Services</router-link></li>
            <li><router-link to="/Services/GIS">Geographical Information Systems (GIS)</router-link></li>
            <li><router-link to="/Services/BI">Business Intelligence</router-link></li>
          </ul>
        </b-col>

        <b-col sm="12" md="2">
          <div class="category">
            <router-link to="/About">{{about.about}}</router-link>
          </div>
          <ul class="list">
          <li><router-link to="/About/Dynateam">Dynateam</router-link></li>
            <li><router-link to="/About/Customers">{{about.customers}}</router-link></li>
          </ul>
        </b-col>

        <b-col sm="12" md="2">
          <div class="category">{{contact.contact}}</div>
          <ul class="list">
            <li>{{contact.email}} <a href="mailto:info@dynalab.se">info@dynalab.se</a></li>
            <li>{{contact.address}}</li>
            <li>{{contact.zipcode}}</li>
            <li>{{contact.country}}</li>
          </ul>
        </b-col>
      </b-row>

      <div class="rights">
        <i class="far fa-copyright"></i> Copyright. All rights reserved.
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'siteFooter',
  props: ['language'],
  data () {
    return {
      services: '',
      products: '',
      about: {
        about: '',
        customers: '',
        partners: '',
        newsArchive: '',
        videos: ''
      },
      contact: {
        contact: '',
        phoneHeader: '',
        phoneNumber: '',
        email: '',
        address: '',
        zipcode: '',
        country: ''
      }
    }
  },
  watch: {
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  methods: {
    handleLanguage: function () {
      this.services = this.$root.getHeader(0)
      this.products = this.$root.getHeader(1)
      this.about = {
        about: this.$root.getHeader(2),
        customers: this.$root.getCategory(2, 0),
        partners: this.$root.getCategory(2, 4),
      }
      this.contact = {
        contact: this.$root.getHeader(3),
        phoneHeader: this.$root.getCategoryHeader(3, 0),
        phoneNumber: this.$root.getCategorySummary(3, 0),
        email: this.$root.getCategory(3, 1),
        address: this.$root.getCategory(3, 2),
        zipcode: this.$root.getCategory(3, 3),
        country: this.$root.getCategory(3, 4)
      }
    }
  }
}

</script>

<style scoped>

.footer {
  background: url('../assets/server.jpg') 50% 50% no-repeat;
  padding-top: 25px;
  padding-bottom: 25px;
}

.logo {
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}

.images {
  text-align: center;
}

.image {
  width: 100px;
  height: auto;
  margin: 10px;
}

.category, .category > a {
  font-weight: bold;
  color: #ffffff;
  font-size: 14px;
}

a {
  color: red;
}

.list, .list > li > a {
  list-style-type: none;
  margin: 0;
  padding: 0;
  color: #ffffff;
  font-weight: 300;
  font-size: 12px;
}

.list > li > a:hover, .category > a:hover {
  text-decoration: none;
  text-shadow: 0 0 3px #ffffff;
}

hr {
  background: white;
  box-shadow: 0 0 3px #ffffff;
  opacity: 0.7;
}

.icons {
  text-align: center;
}

.icon {
  margin: 10px;
  color: #ffffff;
}

.rights {
  text-align: center;
  font-size: 10px;
  color: #ffffff;
  opacity: 0.7;
}

.rights > a {
  color: #ffffff;
}

.rights > a:hover {
  text-decoration: none;
  text-shadow: 0 0 3px #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue